import { $logout } from '@/assets/common/common.js';
import WebHttpService from '@shining3d/http-service';
import { XlMessage } from '@shining3d/ui-components';
import _get from 'lodash/get';
import { apiWhiteErrList } from './whiteList';
// 错误信息处理
const errMapCommon = _get( window, 'app.i18n.@shining3d/app.apiErr.common' );
const errMap = _get( window, 'app.i18n.@shining3d/app.apiErr' );
const errMessage = ( val ) => {
	XlMessage({ type: 'error', message: val });
};
const loginOut = () => {
	XlMessage({
		message: _get( errMapCommon, 'landExpiration' ),
		type: 'error'
	});
	$logout();
};

const httpService = new WebHttpService({ baseUrl: window.app.baseURL, whiteList: apiWhiteErrList, errMap, errMapCommon, loginOut, errMessage });

export default httpService;
